import getFetchResponse, { ApiResponse } from '../get-fetch-response'

// platform's payload type
type IsValidCompanyHintPayload = ApiResponse & {
  isValidCompanyHint: boolean
}

type GetIsValidCompanyHint = {
  (companyHint: string): Promise<IsValidCompanyHintPayload>
}

// https://petstore.swagger.io/?url=https://staging-api.thriveglobal.com/v1/swagger.json#/companies/get_companies_get_is_valid_company_hint
export const getIsValidCompanyHint: GetIsValidCompanyHint = async (
  companyHint
) => {
  const queryParams = { companyHint }
  const res = await getFetchResponse<IsValidCompanyHintPayload>(
    {
      method: 'GET',
      path: '/v2/companies/get_is_company_hint_valid',
      queryParams,
    },
    true
  )

  return res
}
